/**
 * Composant pour la page principale de la pointeuse
 * @returns 
 */

import { TimeClock } from "@/components/timeclock/TimeClock";

export const Pointeuse = () => {
  return (
      <TimeClock />
  );
};
